import { Component } from '@angular/core';
import { ImageSideComponent } from '../../image-side/image-side.component';
import { InputStaticFieldsComponent } from '../../input-static-fields/input-static-fields.component';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '../../../services/translation/translation.service';
import { ReseetPasswordService } from '../service/reseet-password.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-reset-password',
  imports: [InputStaticFieldsComponent,ImageSideComponent,CommonModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {

  resetPasswordForm !: FormGroup;
  showErrorDiv:boolean = false;
  currentMessage!:string;
  constructor(public fb:FormBuilder,public translationService: TranslationService,
    public resetPasswordService:ReseetPasswordService, public loadingService:LoaderService,
    public router:Router) {
    this.resetPasswordForm = this.fb.group({
      email:[this.resetPasswordService.getEmail(),[]],
      password:['',Validators.required],
      code:['',Validators.required]
   });    
  } 

  translate(key: string): string {
    return this.translationService.translate(key);
  }
  close(){
    this.showErrorDiv = false;
  }
onSubmit(): void {
    if (this.resetPasswordForm.valid) {
      this.loadingService.showSpinner();
      this.resetPasswordService.resetPassword(this.resetPasswordForm.value).subscribe({
        next: (data: any) => {
          this.loadingService.stopSpinner();
          this.router.navigateByUrl('/');
        },
        error: (error: any) => {
          this.loadingService.stopSpinner();
          let apiError = error.error?.error || 'An unexpected error occurred';

          // Handle specific validation error for confirmationCode
          if (apiError.includes('validation error detected') && apiError.includes('confirmationCode')) {
            this.currentMessage = 'Invalid confirmation code. Please ensure it contains no spaces or invalid characters.';
          }
          // Handle "Error confirming password reset: " prefixed errors
          else if (apiError.includes('Error confirming password reset: ')) {
            this.currentMessage = apiError.replace('Error confirming password reset: ', '');
          }
          // Handle JSON string errors (e.g., from UpdatePasswordComponent)
          else if (apiError.startsWith('{"error":"')) {
            try {
              const parsedError = JSON.parse(apiError).error;
              this.currentMessage = parsedError.replace('Error changing password: ', '');
            } catch (e) {
              this.currentMessage = apiError;
            }
          }
          // Handle plain error messages (e.g., "Error changing password: pass has been previously used")
          else if (apiError.startsWith('Error changing password: ')) {
            this.currentMessage = apiError.replace('Error changing password: ', '');
          }
          // Fallback for unexpected error formats
          else {
            this.currentMessage = apiError;
          }

          this.showErrorDiv = true;
        },
      });
    }
  }
}
